import React from "react";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "../language";

// Sprachauswahl (gleiche Komponente wie auf der Startseite)
function LanguageTooltip({ align = "right" }) {
  const { t } = useTranslation();
  return <LanguageDropdown align={align} label={t("rpLanguage")} />;
}

export default LanguageTooltip;
